module.exports = __webpack_public_path__ + "img/1w.776ff20e.svg";